import { render, staticRenderFns } from "./control-planificacion.vue?vue&type=template&id=33cbc152&scoped=true"
import script from "./control-planificacion.vue?vue&type=script&lang=js"
export * from "./control-planificacion.vue?vue&type=script&lang=js"
import style0 from "./control-planificacion.vue?vue&type=style&index=0&id=33cbc152&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cbc152",
  null
  
)

export default component.exports